import { react2panel } from 'common/util/react2panel';
import { InsightsBarChartReact } from './index';
export const InsightsBarChartEl = react2panel("mp-insights-bar-chart", InsightsBarChartReact, {
  contexts: ["segmentFilterController"]
});